module.exports = __webpack_public_path__ + "img/banner-princiapal.2db0a5cf.png";